<template>
    <div class="bg container-fluid">
      <div v-if="!error" class="row">
          <div class="polaroid-images col-sm">
            <a href="" >
              <auto-rotate>
                <img class="rotate90" height="200" :src="outfit.imageURL" />
              </auto-rotate></br>
              <p class="polaroid-label">{{outfit.name}}</p>
            </a>
          </div>
      </div>
      <div v-else>
        Nothing to see here. Perhaps you didn't have a photo?
      </div>
    </div>
</template>

<script>
  import {db} from '../firebaseConfig.js'
  export default {
    name: "Share",
    data: function() {
      return {
        outfit: null,
        error:true
      }
    },
    mounted() {
      this.$gtm.trackView('Share', '/');
      fbq('track', 'PageView');
    },
    created: function() {
      console.log(this.$route.query.outfitID)
      this.lookupOutfit(this.$route.query.outfitID)
    },
    methods: {
      lookupOutfit: function(id) {
        console.log("outfit id: ", id)
        // -LUCy07YNK8R68jRwwdo
        const outfitsRef = db.ref("outfits/"+id)
        console.log("outfits ref: ", outfitsRef)
        const outfitQuery = outfitsRef.once('value')
        .then((snapshot) => {
          this.outfit = snapshot.val()
        }).catch(() => {
          this.error = true
        })
        this.error = false
      }
    }
  }
</script>

<style scoped>
  .bg{
    background-image: url("https://images.unsplash.com/photo-1518548235008-15c2e3a4fdd3?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=0e047d9373845c928b6810ec157a932a&auto=format&fit=crop&w=1656&q=80");
    object-fit: cover;
  }
  .keep-it-one-hunnid{
    display: block;
    width: 320px;
    margin-bottom: 12px;
  }
  img .keep-it-one-hunnid{
    max-width: 100%;
    height: auto;
  }
  .polaroid-label{
    text-align: center;
    font-family: "Marker Felt", sans-serif;
    text-decoration: none;
    color: #333;
    font-size: 18px;
  }
  .rotate90 {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  .polaroid-images a
  {
    background: white;
    display: inline;
    float: left;
    margin: 0 15px 30px;
    padding: 10px 10px 25px;
    text-align: center;
    text-decoration: none;
    -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, .3);
    -moz-box-shadow: 0 4px 6px rgba(0,0,0,.3);
    box-shadow: 0 4px 6px rgba(0,0,0,.3);
    -webkit-transition: all .15s linear;
    -moz-transition: all .15s linear;
    transition: all .15s linear;
    z-index:0;
    position:relative;
  }
  .polaroid-images a:after {
    color: #333;
    font-size: 20px;
    content: attr(title);
    position: relative;
    top:15px;
  }
  .polaroid-images img {
    display: block;
    width: inherit;
  }
  .polaroid-images a:nth-child(2n)
  {
    -webkit-transform: rotate(4deg);
    -moz-transform: rotate(4deg);
    transform: rotate(4deg);
  }
  .polaroid-images a:nth-child(3n) {
    -webkit-transform: rotate(-24deg);
    -moz-transform: rotate(-24deg);
    transform: rotate(-24deg);
  }
  .polaroid-images a:nth-child(4n)
  {
    -webkit-transform: rotate(14deg);
    -moz-transform: rotate(14deg);
    transform: rotate(14deg);
  }
  .polaroid-images a:nth-child(5n)
  {
    -webkit-transform: rotate(-18deg);
    -moz-transform: rotate(-18deg);
    transform: rotate(-18deg);
  }
  .polaroid-images a:hover{
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    transform: scale(1.2);
    z-index:10;
    -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, .7);
    -moz-box-shadow: 0 10px 20px rgba(0,0,0,.7);
    box-shadow: 0 10px 20px rgba(0,0,0,.7);
  }
</style>
